import _regeneratorRuntime from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Mon Apr 01 2019
 * @author SKu
 */
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { Release } from '@logio/common-be-fe';
import { runInAction } from 'mobx';
import { StoreName } from '../StoreName';
import { AbstractReleaseStore } from './AbstractReleaseStore';
/**
 * Release store
 */

export var ReleaseStore =
/*#__PURE__*/
function (_AbstractReleaseStore) {
  _inherits(ReleaseStore, _AbstractReleaseStore);

  function ReleaseStore() {
    var _this;

    _classCallCheck(this, ReleaseStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReleaseStore).apply(this, arguments));
    /** @inheritDoc */

    _this.name = StoreName.Release;
    return _this;
  }
  /**
   * Converts array of ReleaseTotalDTO to Map
   * where if impact inside object relates to priceZone
   * (priceZoneId exists), key will be set as categoryId and priceZoneId separated by "_",
   * otherwise, key - categoryId
   * @param totals
   */


  _createClass(ReleaseStore, [{
    key: "getTotalsAsMap",
    value: function getTotalsAsMap(totals) {
      var totalMap = new Map();
      totals.map(function (dto) {
        totalMap.set(dto.priceZoneId ? "".concat(dto.categoryId, "_").concat(dto.priceZoneId) : dto.categoryId, dto);
      });
      return totalMap;
    }
    /** @inheritDoc */

  }, {
    key: "getOne",
    value: function getOne(releaseId) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var release;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.t0 = Release;
                _context.next = 4;
                return this.releaseLayer.findOne(releaseId);

              case 4:
                _context.t1 = _context.sent;
                release = _context.t0.requireRegularRelease.call(_context.t0, _context.t1);
                runInAction(function () {
                  return _this2.release = release;
                });
                return _context.abrupt("return", release);

              case 10:
                _context.prev = 10;
                _context.t2 = _context["catch"](0);
                return _context.abrupt("return", this.handleCatchError(_context.t2, 'getOne'));

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 10]]);
      }));
    }
    /** @inheritDoc */

  }, {
    key: "create",
    value: function create(newRelease) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _this3 = this;

        var release;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.t0 = Release;
                _context2.next = 4;
                return this.releaseLayer.create(newRelease);

              case 4:
                _context2.t1 = _context2.sent;
                release = _context2.t0.requireRegularRelease.call(_context2.t0, _context2.t1);
                runInAction(function () {
                  return _this3.release = release;
                });
                return _context2.abrupt("return", release);

              case 10:
                _context2.prev = 10;
                _context2.t2 = _context2["catch"](0);
                return _context2.abrupt("return", this.handleCatchError(_context2.t2, 'create'));

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 10]]);
      }));
    }
    /** @inheritDoc */

  }, {
    key: "update",
    value: function update(newRelease) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var _this4 = this;

        var release;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.t0 = Release;
                _context3.next = 4;
                return this.releaseLayer.update(newRelease);

              case 4:
                _context3.t1 = _context3.sent;
                release = _context3.t0.requireRegularRelease.call(_context3.t0, _context3.t1);
                runInAction(function () {
                  return _this4.release = release;
                });
                return _context3.abrupt("return", release);

              case 10:
                _context3.prev = 10;
                _context3.t2 = _context3["catch"](0);
                return _context3.abrupt("return", this.handleCatchError(_context3.t2, 'update'));

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 10]]);
      }));
    }
    /** @inheritDoc */

  }, {
    key: "open",
    value: function open(id) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var _this5 = this;

        var release;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.t0 = Release;
                _context4.next = 4;
                return this.releaseLayer.open(id);

              case 4:
                _context4.t1 = _context4.sent;
                release = _context4.t0.requireRegularRelease.call(_context4.t0, _context4.t1);
                runInAction(function () {
                  return _this5.release = release;
                });
                return _context4.abrupt("return", release);

              case 10:
                _context4.prev = 10;
                _context4.t2 = _context4["catch"](0);
                return _context4.abrupt("return", this.handleCatchError(_context4.t2, 'open'));

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 10]]);
      }));
    }
    /** @inheritDoc */

  }, {
    key: "setReleaseFavorability",
    value: function setReleaseFavorability(releaseId, state) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var _this6 = this;

        var release;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.t0 = Release;
                _context5.next = 4;
                return this.releaseLayer.setReleaseFavorability(releaseId, state);

              case 4:
                _context5.t1 = _context5.sent;
                release = _context5.t0.requireRegularRelease.call(_context5.t0, _context5.t1);
                runInAction(function () {
                  return _this6.release = release;
                });
                return _context5.abrupt("return", release);

              case 10:
                _context5.prev = 10;
                _context5.t2 = _context5["catch"](0);
                return _context5.abrupt("return", this.handleCatchError(_context5.t2, 'setReleaseFavorability'));

              case 13:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 10]]);
      }));
    }
    /**
     * Fetches ReleaseTotalDTO objects, if impact inside object relates to priceZone
     * (priceZoneId exists), key will be set as categoryId and priceZoneId separated by "_",
     * otherwise, key - categoryId
     * @param id releaseId
     * @param filter filtering settings
     * @returns Map of ReleaseTotalDTO objects
     */

  }, {
    key: "getTotal",
    value: function getTotal(releaseId, filter) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        var totalDTOs;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return this.releaseLayer.findTotals(releaseId, filter);

              case 3:
                totalDTOs = _context6.sent;
                return _context6.abrupt("return", this.getTotalsAsMap(totalDTOs));

              case 7:
                _context6.prev = 7;
                _context6.t0 = _context6["catch"](0);
                return _context6.abrupt("return", this.handleCatchError(_context6.t0, 'getTotal'));

              case 10:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 7]]);
      }));
    }
    /**
     * Fetches ReleaseTotalDTO objects as Impact, first element is common subtotal
     * rest of them is
     * otherwise, key - categoryId
     * @param id releaseId
     * @param catId categoryId
     * @param relItemIds array of release item ids
     * @returns Map of ImpactRecord with priceZoneId as key
     */

  }, {
    key: "getSubtotals",
    value: function getSubtotals(id, catId, relItemIds) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return this.releaseLayer.findSubtotals(id, catId, relItemIds);

              case 3:
                return _context7.abrupt("return", _context7.sent);

              case 6:
                _context7.prev = 6;
                _context7.t0 = _context7["catch"](0);
                return _context7.abrupt("return", this.handleCatchError(_context7.t0, 'getTotal'));

              case 9:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[0, 6]]);
      }));
    }
    /** @inheritDoc */

  }, {
    key: "getItems",
    value: function getItems(releaseId, filter) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return this.releaseLayer.findItems(releaseId, filter);

              case 3:
                return _context8.abrupt("return", _context8.sent);

              case 6:
                _context8.prev = 6;
                _context8.t0 = _context8["catch"](0);
                return _context8.abrupt("return", this.handleCatchError(_context8.t0, 'getItems'));

              case 9:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[0, 6]]);
      }));
    }
    /**
     * Function updates 'export' flag for releaseItem
     * @param id releaseItemId
     * @param exported - new value of Release Item
     */

  }, {
    key: "exportItem",
    value: function exportItem(id, exported) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9() {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                _context9.next = 3;
                return this.releaseLayer.exportItem(id, exported);

              case 3:
                return _context9.abrupt("return", _context9.sent);

              case 6:
                _context9.prev = 6;
                _context9.t0 = _context9["catch"](0);
                return _context9.abrupt("return", this.handleCatchError(_context9.t0, 'exportItem'));

              case 9:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[0, 6]]);
      }));
    }
    /**
     * Function updates PriceCode of certain priceZone for releaseItem
     * @param id releaseItemId
     * @param data
     */

  }, {
    key: "editItemPriceCode",
    value: function editItemPriceCode(id, data) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10() {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                _context10.next = 3;
                return this.releaseLayer.editItemPriceCode(id, data);

              case 3:
                return _context10.abrupt("return", _context10.sent);

              case 6:
                _context10.prev = 6;
                _context10.t0 = _context10["catch"](0);
                return _context10.abrupt("return", this.handleCatchError(_context10.t0, 'editItemPriceCode'));

              case 9:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this, [[0, 6]]);
      }));
    }
    /**
     * Function updates FinalPrice of certain priceZone for releaseItem
     * @param id releaseItemId
     * @param finalPrice {FinalProductPrice}
     */

  }, {
    key: "editItemFinalPrice",
    value: function editItemFinalPrice(id, finalPrice) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee11() {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;
                _context11.next = 3;
                return this.releaseLayer.editItemFinalPrice(id, finalPrice);

              case 3:
                return _context11.abrupt("return", _context11.sent);

              case 6:
                _context11.prev = 6;
                _context11.t0 = _context11["catch"](0);
                return _context11.abrupt("return", this.handleCatchError(_context11.t0, 'editItemFinalPrice'));

              case 9:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this, [[0, 6]]);
      }));
    }
    /**
     * Function updates Price Comment of certain priceZone for releaseItem
     * @param id releaseItemId
     * @param comment {PriceCommentSaveRequest}
     */

  }, {
    key: "createItemComment",
    value: function createItemComment(id, comment) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee12() {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;
                return _context12.abrupt("return", this.releaseLayer.createItemComment(id, comment));

              case 4:
                _context12.prev = 4;
                _context12.t0 = _context12["catch"](0);
                return _context12.abrupt("return", this.handleCatchError(_context12.t0, 'createItemComment'));

              case 7:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this, [[0, 4]]);
      }));
    }
    /**
     * Copy Release settings to general Settings
     * @param releaseId
     */

  }, {
    key: "saveToGeneralSettings",
    value: function saveToGeneralSettings(releaseId) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee13() {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.prev = 0;
                _context13.next = 3;
                return this.releaseLayer.saveToGeneralSettings(releaseId);

              case 3:
                return _context13.abrupt("return", _context13.sent);

              case 6:
                _context13.prev = 6;
                _context13.t0 = _context13["catch"](0);
                return _context13.abrupt("return", this.handleCatchError(_context13.t0, 'saveToGeneralSettings'));

              case 9:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this, [[0, 6]]);
      }));
    }
    /** @inheritDoc */

  }, {
    key: "getPromos",
    value: function getPromos(id, zoneId) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee14() {
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.prev = 0;
                _context14.next = 3;
                return this.releaseLayer.findPromos(id, zoneId);

              case 3:
                return _context14.abrupt("return", _context14.sent);

              case 6:
                _context14.prev = 6;
                _context14.t0 = _context14["catch"](0);
                return _context14.abrupt("return", this.handleCatchError(_context14.t0, 'getPromos'));

              case 9:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this, [[0, 6]]);
      }));
    }
  }, {
    key: "updateReleasePartManualPrices",
    value: function updateReleasePartManualPrices(releaseId, categoryId, manualPrices) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee15() {
        var _this7 = this;

        var releasePart;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.prev = 0;
                _context15.next = 3;
                return this.releaseLayer.updateReleasPartManualPrices(releaseId, categoryId, manualPrices);

              case 3:
                releasePart = _context15.sent;
                runInAction(function () {
                  return _this7.release.releaseParts.set(_this7.release.releaseParts.findIndex(function (part) {
                    return part.productCategoryId === releasePart.productCategoryId;
                  }), releasePart);
                });
                return _context15.abrupt("return", releasePart);

              case 8:
                _context15.prev = 8;
                _context15.t0 = _context15["catch"](0);
                return _context15.abrupt("return", this.handleCatchError(_context15.t0, 'updateReleasePartManualPrices'));

              case 11:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this, [[0, 8]]);
      }));
    }
    /**
     * Recalculates release parts which requires to be recalculated. Also sets manualPrice before that.
     * Release entity will be updated.
     *
     * @param releaseId
     * @param manualPrices
     */

  }, {
    key: "recalculateNeededReleaseParts",
    value: function recalculateNeededReleaseParts(releaseId, manualPrices) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee16() {
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.prev = 0;
                _context16.next = 3;
                return this.releaseLayer.recalculateNeededReleaseParts(releaseId, manualPrices);

              case 3:
                _context16.next = 5;
                return this.getOne(releaseId);

              case 5:
                _context16.next = 10;
                break;

              case 7:
                _context16.prev = 7;
                _context16.t0 = _context16["catch"](0);
                return _context16.abrupt("return", this.handleCatchError(_context16.t0, 'recalculateNeededReleaseParts'));

              case 10:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this, [[0, 7]]);
      }));
    }
    /********************************************************************** Price Impact Report **************************************************************************/

    /** @inheritDoc */

  }, {
    key: "getTotalWithImpact",
    value: function getTotalWithImpact(id, params) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee17() {
        var totalDTOs;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.prev = 0;
                _context17.next = 3;
                return this.releaseLayer.findTotalWithImpact(id, params);

              case 3:
                totalDTOs = _context17.sent;
                return _context17.abrupt("return", this.getTotalsAsMap(totalDTOs));

              case 7:
                _context17.prev = 7;
                _context17.t0 = _context17["catch"](0);
                return _context17.abrupt("return", this.handleCatchError(_context17.t0, 'getTotal'));

              case 10:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this, [[0, 7]]);
      }));
    }
    /** @inheritDoc */

  }, {
    key: "getItemsWithImpact",
    value: function getItemsWithImpact(id, params) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee18() {
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.prev = 0;
                _context18.next = 3;
                return this.releaseLayer.findItemsWithImpact(id, params);

              case 3:
                return _context18.abrupt("return", _context18.sent);

              case 6:
                _context18.prev = 6;
                _context18.t0 = _context18["catch"](0);
                return _context18.abrupt("return", this.handleCatchError(_context18.t0, 'getTotal'));

              case 9:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this, [[0, 6]]);
      }));
    }
    /********************************************************************** Site Release Upload **************************************************************************/

  }, {
    key: "uploadSiteRelease",
    value: function uploadSiteRelease(dataFile, name, description) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee19() {
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.prev = 0;
                _context19.next = 3;
                return this.siteReleaseLayer.uploadRegularSiteRelease(dataFile, name, description);

              case 3:
                return _context19.abrupt("return", _context19.sent);

              case 6:
                _context19.prev = 6;
                _context19.t0 = _context19["catch"](0);
                return _context19.abrupt("return", this.handleCatchError(_context19.t0, 'priceUpload'));

              case 9:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this, [[0, 6]]);
      }));
    }
  }, {
    key: "getSiteReleaseUpload",
    value: function getSiteReleaseUpload(id) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee20() {
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.prev = 0;
                _context20.next = 3;
                return this.siteReleaseLayer.getRegularSiteReleaseUpload(id);

              case 3:
                return _context20.abrupt("return", _context20.sent);

              case 6:
                _context20.prev = 6;
                _context20.t0 = _context20["catch"](0);
                return _context20.abrupt("return", this.handleCatchError(_context20.t0, 'priceUpload'));

              case 9:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this, [[0, 6]]);
      }));
    }
  }]);

  return ReleaseStore;
}(AbstractReleaseStore);